import { Step, StepProps } from './Step';

export interface SectionBlockProps {
    steps: StepProps[];
    imageUrl: string;
    imageSide: 'left' | 'right';
    showButton?: boolean;
    demoController: () => void;
}

export const SectionBlock: React.FC<SectionBlockProps> = ({ steps, imageUrl, imageSide, showButton, demoController }) => {
    const imageOrderClass = imageSide === 'left' ? 'lg:order-first' : 'lg:order-last';
    // const [showDemo, setShowDemo] = useState(false);


    return (
        <>
            {/* {showDemo === true && (
                <BookDemo demoController={demoController} />
            )} */}
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 lg:gap-16">
                {/* --- Text Content --- */}
                <div className="flex flex-col space-y-8">
                    {steps.map((step) => (
                        <Step key={step.number} {...step} />
                    ))}
                    {showButton && (
                        <div className="pt-4 flex pl-[64px]">
                            <button
                                className="bg-blue-100 px-10 font-[600] max-md:px-[78px]    py-3 text-white  transition duration-300 ease-in-out  hover:scale-[1.05] hover:bg-gradient-to-l rounded-md mr-4 max-md:mr-0 bg-gradient-to-r from-blue-500 to-purple-600"
                                onClick={demoController}
                            >
                                Book a Demo
                            </button>
                        </div>
                    )}
                </div>

                {/* --- Image Content --- */}
                <div
                    className={`flex justify-center items-center ${imageOrderClass} p-[100px] max-md:p-[30px] rounded-xl`}
                    style={{
                        background: 'linear-gradient(270deg, rgba(19, 108, 197, 0.3) 0%, rgba(255, 255, 255, 0) 115.37%)',
                    }}
                >
                    <img
                        src={imageUrl}
                        alt="Blockchain Process Illustration"
                        className="max-w-full h-auto rounded-lg"
                    />
                </div>
            </div>
        </>
    );
};